import { useContext } from 'react';

import MasterIdManagerContext, { MasterIdManagerContextValues } from './context';

const useMasterIdManager = (): MasterIdManagerContextValues => useContext(MasterIdManagerContext);

export default useMasterIdManager;
